import React, { useEffect, useState } from 'react';
import { ComplianceSection } from '@fiverr-private/compliance';
import { useAgencySellerData } from '../../hooks/useAgencySellerData';
import { AgencySeller } from '../../types';

export const ComplianceArea = ({ sellerId }: { sellerId: number }) => {
    const { username } = useAgencySellerData(selectSellerSlice);
    const [rerenderKey, setRerenderKey] = useState(0);
    // workaround to re-render the compliance section to remove auto applied styles
    useEffect(() => {
        setRerenderKey(Date.now());
        return () => {
            setRerenderKey(0);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return <ComplianceSection requeseteeId={sellerId} requeseteeUserName={username} key={rerenderKey} />;
};

const selectSellerSlice = ({ user: { name } }: AgencySeller) => ({
    username: name,
});
